import Col from "../../../common/DataTableV2/Col";
import React from "react/lib/React";
import followUpPriorities, { URGENT, TWODAYS } from "../../clients/client/notes/enums/followUpPriorities";
import { FormattedDate, FormattedMessage, FormattedTime } from "react-intl";
import { Tooltip } from "react-bootstrap";
import { OverlayRenderer } from "../../../common";
import classNames from "classnames";
import { FOLLOW_UP_CATEGORIES } from "../../../../utils/enums/enums";
import { EnumValue, EnumWrapper } from "../../../../utils/enums";
import followUpStatusTypes from "../../clients/client/notes/enums/followUpStatusTypes";
import userHasAccess from "../../../../utils/userHasAccess";
import { FINTECH } from "../../../../utils/Roles";

export const getFollowUpCols = ({
    filtrableCols,
    onHeaderFilterChange,
    updateMasterCheckbox,
    checkboxes,
    setCellClassNames,
    paginationQuery
}) => {
    let displayedPriority;    
    const checkBoxCol = new Col(
        "",
        (followUp) => {
            const isMemberArchived = followUp.member && followUp.member.isArchived && !userHasAccess(FINTECH);
            if (followUp.followUpStatusType === "OPEN" && !isMemberArchived) {
                return (
                    <input
                    ref={(ref) => (ref ? (checkboxes[followUp.followUpId] = ref) : null)}
                    type="checkbox"
                    value={followUp.followUpId}
                    onChange={updateMasterCheckbox}
                    />
                    );
                }
            },
        3,
        false
    );

    const priorityCol = new Col(
        <FormattedMessage id="followUps.list.datatable.columns.priority" />,
        (followUp) => {
            return (
                <span
                    className={
                        setCellClassNames(followUp) + followUp.priority == URGENT.value
                            ? " critical-value"
                            : followUp.priority == TWODAYS.value
                            ? " warning-value"
                            : ""
                    }
                >
                    {((displayedPriority = followUpPriorities.find(
                        (priority) => priority.value === followUp.priority
                    ))) ? (
                        <FormattedMessage id={displayedPriority.key} />
                    ) : (
                        ""
                    )}
                </span>
            );
        },
        6,
        "follow_ups.priority",
        true,
        filtrableCols.selectedPriorities,
        "followUps.list.datatable.columns.priority",
        onHeaderFilterChange,
        true,
        false,
        "fu-small-menus"
    );

    const createdAtCol = new Col(
        <FormattedMessage id="followUps.list.datatable.columns.date" />,
        (followUp) => {
            const formattedCreatedAt = followUp.createdAt.split(".")[0] + "Z";
            const dateObj = Date.parse(formattedCreatedAt);
            return (
                <span className={`highlighted-datetime ${setCellClassNames(followUp)}`}>
                    <span className="date short-date-format">
                        <FormattedDate value={dateObj} year="numeric" month="2-digit" day="2-digit" />
                        <FormattedTime value={formattedCreatedAt} hour="numeric" minute="numeric" />
                    </span>
                </span>
            );
        },
        7,
        "follow_ups.created_at",
        true,
        filtrableCols.selectedCreatedAt,
        "followUps.list.datatable.columns.creation",
        onHeaderFilterChange,
        false,
        true,
        "fu-small-menus",
        true,
        true
    );

    const deadlineCol = new Col(
        <FormattedMessage id="followUps.list.datatable.columns.deadline" />,
        (followUp) => {
            let formattedDeadline = "";
            let dateObj = null;
            if (followUp.deadline) {
                formattedDeadline = followUp.deadline.split(".")[0] + "Z";
                dateObj = Date.parse(formattedDeadline);
            }

            return dateObj ? (
                <span className={`highlighted-datetime ${setCellClassNames(followUp)}`}>
                    <span className="date short-date-format">
                        <FormattedDate value={dateObj} year="numeric" month="2-digit" day="2-digit" />
                        {followUp.deadline ? (
                            <FormattedTime value={formattedDeadline} hour="numeric" minute="numeric" />
                        ) : (
                            ""
                        )}
                    </span>
                </span>
            ) : (
                <span className="nd-deadline"><FormattedMessage id="common.nd" /></span>
            );
        },
        7,
        "follow_ups.deadline",
        true,
        filtrableCols.selectedDeadline,
        "followUps.list.datatable.columns.deadline",
        onHeaderFilterChange,
        false,
        true,
        "fu-small-menus"
    );

    const creatorCol = new Col(
        <FormattedMessage id="followUps.list.datatable.columns.creator" />,
        (followUp) => {
            if (followUp.createdByUser) {
                return `${followUp.createdByUser.firstName} ${followUp.createdByUser.lastName}`;
            }
        },
        10,
        "follow_ups.created_by_user",
        true,
        filtrableCols.selectedCreators,
        "followUps.list.datatable.columns.creator",
        onHeaderFilterChange,
        false,
        true,
        "fu-name-menus"
    );
 const clientCol = new Col( 
        <FormattedMessage id="followUps.list.datatable.columns.client" />,
        (followUp) => {
            if(!!followUp.client && followUp.extraData.isVip === true) {
                
                return (
                  <a href={`/dashboard/clients/${followUp.clientId}`} target="_blank" rel="noopener noreferrer"> 
                    <span className="name-border">
                        {followUp.client.name}
                    </span>
                </a>
                );
            }
            if(followUp.clientId==null){
                return(
                     <span>
                   <FormattedMessage id="common.nd" />
                </span>
                );              
            }         
            return (

                <a href={`/dashboard/clients/${followUp.clientId}`} target="_blank" rel="noopener noreferrer">                               
                <span>
                    {!!followUp.client ? followUp.client.name : <FormattedMessage id="common.nd" />}
                </span>
                </a>
            );
        },
        10,
        "follow_ups.client",
        true,
        filtrableCols.selectedClients,
        "followUps.list.datatable.columns.client",
        onHeaderFilterChange,
        false,
        true,
        "fu-client-menu"
    );
    const memberCol = new Col(
        <FormattedMessage id="followUps.list.datatable.columns.member" />,
        (followUp) => {
            if (!!followUp.member) {
                return (
                    <span className={`align-cell-text-left ${setCellClassNames(followUp)}`}>
                        <a
                            className="member-link"
                            href={`/dashboard/clients/${followUp.member.client.clientId}/members/${followUp.member.memberId}/profile`}
                            target="_blank"
                        >
                            <span className="member">{`${followUp.member.firstName} ${followUp.member.lastName}`}</span>
                        </a>
                        <br />
                        <a
                            className="client-link"
                            href={`/dashboard/clients/${followUp.member.client.clientId}`}
                            target="_blank"
                        >
                            <span className="additional-info client">
                                {!!followUp.member && !!followUp.member.client ? (
                                    `${followUp.member.client.name} - ${followUp.member.memberIdentifier}`
                                ) : (
                                    <FormattedMessage id="common.nd" />
                                )}
                            </span>
                        </a>
                    </span>
                );
            } else {
                return (
                    <span className={`align-cell-text-left ${setCellClassNames(followUp)}`}>
                        <span className="member">
                            <FormattedMessage id="common.nd" />
                        </span>
                        <br />
                        <span className="additional-info client">
                            <FormattedMessage id="common.nd" />
                            &nbsp;-&nbsp;
                            <FormattedMessage id="common.nd" />
                        </span>
                    </span>
                );
            }
        },
        9,
        "follow_ups.member_name",
        true,
        filtrableCols.selectedMembers,
        "followUps.list.datatable.columns.member",
        onHeaderFilterChange,
        false,
        true,
        "fu-name-menus"
    );

    const descriptionCol = new Col(
        <FormattedMessage id="followUps.list.datatable.columns.description" />,
        (followUp) => {
            const tooltip = (
                <Tooltip id={followUp.followUpId} className="line-break-tooltip">
                    {followUp.description}
                </Tooltip>
            );
            return (
                <OverlayRenderer
                    placement="left"
                    overlay={tooltip}
                    overlayedClassName="tooltipped-cell"
                    forceOverlay={/[\r\n]/.test(followUp.description)}
                >
                    <span>{followUp.description}</span>
                </OverlayRenderer>
            );
        },
        14,
        "follow_ups.description",
        true,
        filtrableCols.selectedDescriptions,
        "followUps.list.datatable.columns.description",
        onHeaderFilterChange,
        false,
        true
    );

    const commentAttachments = new Col(
        "",
        (followUp) => {
            const commentsAttachmentsClasses = classNames({
                "comments-attachments": true,
            });
            const comments = followUp.commentsCount ? (
                <span className="comment-count">
                    <span>{followUp.commentsCount > 99 ? "99+" : followUp.commentsCount}</span>
                </span>
            ) : (
                ""
            );
            const attachments = followUp.attachmentsCount ? <span className="icon-attachment" /> : "";
            return (
                <div className={commentsAttachmentsClasses}>
                    {comments}
                    {attachments}
                </div>
            );
        },
        3
    );

    const recipientUser = new Col(
        <FormattedMessage id="followUps.list.datatable.columns.assigned" />,
        (followUp) => (
            <span className={setCellClassNames(followUp)}>
                {!!followUp.recipientUser ? (
                    `${followUp.recipientUser.firstName} ${followUp.recipientUser.lastName}`
                ) : (
                    <FormattedMessage id="common.nd" />
                )}
            </span>
        ),
        10,
        "follow_ups.recipient_user",
        true,
        filtrableCols.selectedAssigned,
        "followUps.list.datatable.columns.assigned",
        onHeaderFilterChange,
        false,
        true,
        "fu-name-menus"
    );

    const followUpCategory = new Col(
        <FormattedMessage id="followUps.list.datatable.columns.category" />,
        (followUp) => (
            <span className={setCellClassNames(followUp)}>
                <EnumWrapper query={paginationQuery} enum={FOLLOW_UP_CATEGORIES}>
                    <EnumValue enumKey={followUp.followUpCategory.followUpCategoryId} />
                </EnumWrapper>
            </span>
        ),
        8,
        "follow_ups.follow_up_category",
        true,
        filtrableCols.selectedCategories,
        "followUps.list.datatable.columns.category",
        onHeaderFilterChange,
        true,
        true,
        "fu-category-menu"
    );

    const followUpStatus = new Col(
        <FormattedMessage id="followUps.list.datatable.columns.status" />,
        (followUp) => {
            return (
                <span
                    className={`status-indicator status-${followUp.followUpStatusType
                        .toLowerCase()
                        .replace(/_/g, "-")} ${setCellClassNames(followUp)}`}
                >
                    <span className="status">
                        <FormattedMessage
                            id={followUpStatusTypes.find((type) => type.value === followUp.followUpStatusType).key}
                        />
                    </span>
                </span>
            );
        },
        7,
        "follow_ups.follow_up_status_type",
        true,
        filtrableCols.selectedStatuses,
        "followUps.list.datatable.columns.status",
        onHeaderFilterChange,
        false,
        false,
        "fu-small-menus"
    );

    const checkBoxObj = { ...checkBoxCol };
    const priorityObj = { ...priorityCol };
    const createdAtObj = { ...createdAtCol };
    const deadlineObj = { ...deadlineCol };
    const creatorObj = { ...creatorCol };
    const clientObj = { ...clientCol };
    const memberObj = { ...memberCol };
    const descriptionObj = { ...descriptionCol };
    const commentAttachmentsObj = { ...commentAttachments };
    const recipientUserObj = { ...recipientUser };
    const followUpCategoryObj = { ...followUpCategory };
    const followUpStatusObj = { ...followUpStatus };

    return [
        checkBoxObj,
        priorityObj,
        createdAtObj,
        deadlineObj,
        creatorObj,
        clientObj,
        memberObj,
        descriptionObj,
        commentAttachmentsObj,
        recipientUserObj,
        followUpCategoryObj,
        followUpStatusObj,
    ];
};



// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/list/FollowUpsCols.js